export default {
  TEXT: "syncFieldType_TEXT",
  MULTITEXT: "syncFieldType_MULTITEXT",
  DATE: "syncFieldType_DATE",
  CHECKBOX: "syncFieldType_CHECKBOX",
  LIST: "syncFieldType_LIST"
};
